import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { Tooltip } from '@web-chat-core/ui-kit';
import { FullscreenButtonView, FullscreenIcon } from './view';

interface Props {
    onClick: () => void;
    isFullscreenActive?: boolean;
    className?: string;
    isHidden: boolean;
}

export const FullscreenButton: React.FC<Props> = ({ onClick, isFullscreenActive, className, isHidden }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const tooltip = isFullscreenActive ? t('web_screen_sharing_exit_fullscreen') : t('web_screen_sharing_fullscreen');

    return (
        <Tooltip label={tooltip} position="top">
            <FullscreenButtonView onClick={onClick} className={className} $hidden={isHidden}>
                <FullscreenIcon
                    icon={isFullscreenActive ? 'icFullscreenExit' : 'icFullscreen'}
                    size={24}
                    color={theme.root.colors.basicColors['90%']}
                />
            </FullscreenButtonView>
        </Tooltip>
    );
};
